import { SUPPORT_EMAIL } from "./email";

/**
 * Angaben zum Anbieter für Impressum, Datenschutzerklärung und AGB. Nur hier ändern, die Seiten lesen alles von hier.
 * Felder mit `null` erscheinen im Impressum nicht. Vor dem Start müssen sie mit den echten Angaben gefüllt sein.
 */
export const PROVIDER = {
  /** Name, unter dem HandVero betrieben wird. */
  brand: "HandVero",
  /** Inhaber mit Rechtsform, wie es im Impressum steht. */
  owner: "Tobias Rataj",
  legalForm: "Einzelunternehmen",
  street: "Hauptstraße 21",
  zip: "09481",
  city: "Elterlein",
  /** Nur im Impressum, nicht auf der Kontaktseite (Tobias, 26.10.2026). */
  phone: "01520 2313064",
  phoneLink: "+4915202313064",
  email: SUPPORT_EMAIL,
  /** Umsatzsteuer-Identifikationsnummer, falls vorhanden. */
  vatId: "DE370592861" as string | null,
  /** Wahr, wenn der Anbieter Kleinunternehmer nach § 19 UStG ist (dann erscheint der Hinweis statt der USt-IdNr.). */
  smallBusiness: false,
  /** Handelsregister, z. B. "Amtsgericht Chemnitz, HRB 12345". */
  register: null as string | null,
} as const;

/** Stand der rechtlichen Texte, steht am Anfang der Seite. */
export const LEGAL_UPDATED = "31. Oktober 2026";

/** Zuständige Datenschutz-Aufsichtsbehörde für den Sitz des Anbieters. */
export const DATA_AUTHORITY = {
  name: "Sächsische Datenschutz- und Transparenzbeauftragte",
  street: "Devrientstraße 5",
  city: "01067 Dresden",
  web: "https://www.datenschutz.sachsen.de",
} as const;

/**
 * Was heute nutzbar ist und was erst mit der Windows-Software kommt.
 * Die Website zeigt alles, was `available: false` ist, als "bald verfügbar".
 */
export const AVAILABILITY: { name: string; text: string; available: boolean }[] = [
  { name: "Website und Registrierung", text: "Firmenkonto anlegen, Mitarbeiter einladen, Kundenbereich.", available: true },
  { name: "Handy-Web-App", text: "Projekte und Ordner, Fotos direkt in den richtigen Ordner, PDFs ansehen, Notizen und Termine.", available: true },
  { name: "Windows-Software", text: "Das Installationsprogramm für den PC im Büro, im Kundenbereich zum Herunterladen.", available: true },
  { name: "Protokolle und Nachweise", text: "Vorlagen, Unterschrift und fertige PDF-Protokolle.", available: false },
  { name: "Online-Schulungen und Belehrungen", text: "Unterweisungen mit Fragen und Teilnahmebescheinigung.", available: false },
  { name: "Angebote, Aufträge und Rechnungen", text: "Vom Angebot bis zur Mahnung, mit Kunden, Ausgaben und Bankumsätzen. In den bezahlten Paketen enthalten.", available: true },
  { name: "Zeichenprogramm für Installationspläne", text: "Installationsplan und Stromlaufplan.", available: false },
];
